import { useEffect } from 'react';
import queryString from 'query-string';
import Cookies from 'js-cookie';
import { useLocation } from '@gatsbyjs/reach-router';

export const useSubmittedDesignCookie = () => {
  const location = useLocation();

  useEffect(() => {
    const { design_submitted: designSubmitted } = queryString.parse(location.search);
    if (designSubmitted) {
      Cookies.set('design_submitted', 'true');
    }
  }, []);
};
